import logger from './logger';
import axios from 'axios';
import media from '../Assets/bgMedia.png';
import { firebaseVapidKey, googlePlaceKey } from '../Constant/Url';
import dayjs from 'dayjs';
import messaging from '../firebase.config';
import { getToken } from 'firebase/messaging';

/* Detect Browser */
const detectBrowser = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes('chrome')) {
        return 'Chrome';
    } else if (userAgent.includes('firefox')) {
        return 'Firefox';
    } else if (userAgent.includes('safari')) {
        return 'Safari';
    } else if (userAgent.includes('edge')) {
        return 'Edge';
    } else if (userAgent.includes('trident') || userAgent.includes('msie')) {
        return 'IE';
    } else {
        return 'Unknown';
    }
};

export const browserName = detectBrowser();

// export const getLocation = () => {
//     return new Promise((resolve, reject) => {
//         if (navigator.geolocation) {
//             navigator.geolocation.getCurrentPosition(
//                 (position) => {
//                     const coordinates = {
//                         lat: position.coords.latitude,
//                         lng: position.coords.longitude,
//                     };
//                     resolve(coordinates);
//                     return coordinates;
//                 },
//                 (error) => {
//                     // Enhanced error handling
//                     let errorMessage = '';
//                     switch (error.code) {
//                         case error.PERMISSION_DENIED:
//                             errorMessage = "User denied the request for Geolocation.";
//                             break;
//                         case error.POSITION_UNAVAILABLE:
//                             errorMessage = "Location information is unavailable.";
//                             break;
//                         case error.TIMEOUT:
//                             errorMessage = "The request to get user location timed out.";
//                             break;
//                         case error.UNKNOWN_ERROR:
//                             errorMessage = "An unknown error occurred.";
//                             break;
//                         default:
//                             errorMessage = error.message;
//                             break;
//                     }
//                     reject(new Error(errorMessage));
//                 },
//                 {
//                     timeout: 10000, // Set timeout for better UX
//                     maximumAge: 0,  // Force to get current location
//                 }
//             );
//         } else {
//             reject(new Error("Geolocation not supported"));
//         }
//     });
// };
export const getLocation = (options = {}) => {
    const {
        timeout = 10000,
        maximumAge = 0,
        enableHighAccuracy = true,
        retries = 1,
        retryDelay = 1000,
    } = options;

    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error('Geolocation is not supported by your browser'));
            return;
        }

        const checkPermission = () => {
            if (navigator.permissions && navigator.permissions.query) {
                return navigator.permissions
                    .query({ name: 'geolocation' })
                    .then((permissionStatus) => permissionStatus.state)
                    .catch(() => 'unknown');
            }
            return Promise.resolve('unknown');
        };

        const attemptGetLocation = (attempt = 0) => {
            checkPermission().then((permission) => {
                if (permission === 'denied') {
                    reject(
                        new Error(
                            'Location permission was previously denied. Please enable it in browser settings.'
                        )
                    );
                    return;
                }

                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        resolve({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                            accuracy: position.coords.accuracy,
                            altitude: position.coords.altitude,
                            altitudeAccuracy: position.coords.altitudeAccuracy,
                            heading: position.coords.heading,
                            speed: position.coords.speed,
                            timestamp: position.timestamp,
                        });
                    },
                    (error) => {
                        let errorMessage;
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                errorMessage = 'User denied the request for Geolocation.';
                                break;
                            case error.POSITION_UNAVAILABLE:
                                errorMessage = 'Location information is unavailable.';
                                break;
                            case error.TIMEOUT:
                                errorMessage = 'The request to get user location timed out.';
                                break;
                            default:
                                errorMessage = error.message || 'An unknown error occurred.';
                        }
                        if (attempt < retries) {
                            setTimeout(() => attemptGetLocation(attempt + 1), retryDelay);
                        } else {
                            const enhancedError = new Error(errorMessage);
                            enhancedError.code = error.code;
                            enhancedError.permission = permission;
                            reject(enhancedError);
                        }
                    },
                    {
                        enableHighAccuracy,
                        timeout,
                        maximumAge,
                    }
                );
            });
        };
        attemptGetLocation();
    });
};

/* Getting Time Zone */
export const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const dateTimeFormat = (value, format) => {
    let parsedDate = dayjs(value);
    if (!value || !parsedDate.isValid()) {
        return '-';
    }
    return parsedDate.format(format ? format : 'MM/DD/YYYY hh:mm');
};

/* Accept Number */
export const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    // Allow only numeric characters (0-9)
    if (!/^[0-9]+$/.test(keyValue)) {
        event.preventDefault();
    }
};
export const handleKeyPressWithDecimal = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    // Allow only numeric characters, dot, and control keys
    const regex = /^[0-9\b.]+$/;
    const inputValue = event.target.value;

    if (
        !regex.test(keyValue) ||
        inputValue.length >= 10 ||
        (keyValue === '.' && inputValue.includes('.')) ||
        (inputValue === '' && keyValue === '.')
    ) {
        event.preventDefault();
    }
};

/* Formatted Address */
export const getAddress = (data) => {
    const formattedAddress = `${data?.city} ${data?.stateName}, ${data?.country}, ${data?.zipCode}`;
    return formattedAddress;
};

/* Pagination Button */
export const itemRender = (_, type, originalElement) => {
    if (type === 'prev') {
        return <b className="text-white">PREV</b>;
    }
    if (type === 'next') {
        return <b className="text-white">NEXT</b>;
    }
    return originalElement;
};

export const formatPhoneNumber = (phoneNumber) => {
    if (phoneNumber === undefined) return '--';
    const numericPhoneNumber = phoneNumber.replace(/\D/g, '');

    // Apply US phone number format (###) ###-####
    const formattedNumber = numericPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    return formattedNumber;
};

export const getCityName = async ({ lat, lng, googleKey }) => {
    try {
        const response = await axios.get(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${lat},${lng}&key=${googleKey ?? googlePlaceKey}`,
            {
                params: {
                    latlng: `${lat},${lng}`,
                    sensor: true,
                    key: googlePlaceKey,
                },
            }
        );
        if (response?.status === 200) {
            const results = response.data.results;
            let address = response?.data?.results?.[0]?.formatted_address;
            if (results.length > 0) {
                const addressComponents = results[0].address_components;
                const city = addressComponents.find((component) =>
                    component.types.includes('locality')
                )?.long_name;
                const postalCode = addressComponents.find((component) =>
                    component.types.includes('postal_code')
                )?.long_name;
                const country = addressComponents.find((component) =>
                    component.types.includes('country')
                )?.long_name;
                const state = addressComponents.find((component) =>
                    component.types.includes('administrative_area_level_1')
                )?.long_name;
                const data = {
                    lat: lat,
                    lng: lng,
                    city: city,
                    state: state,
                    country: country,
                    zipCode: postalCode,
                    address: address,
                };
                return data;
            } else {
                logger.log('No address details found for the provided coordinates.');
            }
        } else {
            logger.log('Failed to fetch address details:', response?.statusText);
        }
    } catch (err) {
        logger.log('Error fetching data:', err);
    }
};

export const disabledFutureDate = (current) => {
    // Disable all dates after today
    return current && current > dayjs().endOf('day');
};
export const disabledPastDate = (current) => {
    // Disable all dates after today
    return current && current < dayjs().startOf('day');
};

export const isWhitespace = (value) => /^\s*$/.test(value);

export const signUpFormInitialValue = {
    firstName: '',
    lastName: '',
    email: '',
    dob: '',
    phone: '',
    preferred_spa: [],
    password: '',
    confirmPassword: '',
    country: '',
    state: '',
    city: '',
    remember: true,
};
export const dateFormat = `DD/MM/YYYY`;

// Other Browsers Notifications Support Check
export const requestNotificationPermission = async () => {
    if (!('Notification' in window)) {
        alert('This browser does not support desktop notification');
        return;
    }
    try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            logger.log('Notification Granted');
        } else if (permission === 'denied') {
            logger.log('Notification Denied');
        } else if (permission === 'default') {
            logger.log('Notification Prompt Dismissed');
        }
    } catch (error) {
        logger.log('Error requesting notification permission:', error);
    }
};

export const getFCMToken = async () => {
    const token = await getToken(messaging, { vapidKey: firebaseVapidKey });
    return token;
};

/*
 * FCM TOPIC MANAGEMENT — currently stubbed.
 *
 * These used to call https://iid.googleapis.com/iid/v1/... directly from the browser using
 * the Firebase Cloud Messaging *server* key, which meant a privileged secret was shipped in
 * the JS bundle (anyone could extract it and push to every user). The key has been removed.
 *
 * Topic subscribe/unsubscribe is a privileged operation and must run server-side. Once the
 * backend exposes the endpoints, replace the body of each stub with a dispatch through the
 * generic thunk, e.g.:
 *
 *   store.dispatch(apiCallFun({
 *     url: userEndPoint.fcmSubscribeTopicUrl,   // already defined in utils/endPoints.js
 *     method: 'POST',
 *     data: { fcmToken: token, topic },
 *     callBackData: () => {},
 *   }));
 *
 * The backend should subscribe/unsubscribe the token to the caller's own topic plus the
 * global `ToSpaOwner` and `ToCustomer` topics, using an FCM HTTP v1 service account.
 *
 * Signatures are unchanged, so every existing call site keeps working. Receiving push
 * messages is unaffected — only topic membership is inert until the backend ships.
 */
let topicStubWarned = false;
const warnTopicStub = (action) => {
    if (!topicStubWarned) {
        topicStubWarned = true;
        logger.log(
            `FCM ${action}: no-op. Topic management moved server-side; awaiting backend endpoints.`
        );
    }
};

export const subscribeTokenToTopic = (token, topic) => {
    if (!token || !topic) return;
    warnTopicStub('subscribeTokenToTopic');
};

export const unsubscribeTokenFromTopics = (token, topic) => {
    if (!token || !topic) return;
    warnTopicStub('unsubscribeTokenFromTopics');
};

export const playNotificationSound = () => {
    const audio = new Audio('../Assets/notification.wav');
    audio.play().catch((error) => {
        logger.log('Error playing audio:', error);
    });
};

/*  Get Distance in miles */
const toRadians = (degrees) => {
    return degrees * (Math.PI / 180);
};

export const haversineDistance = (coords1, coords2) => {
    const R = 3958.8; // Radius of the Earth in miles
    const lat1 = toRadians(coords1?.[1]);
    const lat2 = toRadians(coords2?.[1]);
    const lon1 = toRadians(coords1?.[0]);
    const lon2 = toRadians(coords2?.[0]);

    const dLat = lat2 - lat1;
    const dLon = lon2 - lon1;

    const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    logger.log('object', R * c);

    return Math.round(R * c);
};

/* CSS Inline Styling */

/* Colors */
export const blackColor = `#000`;
export const whiteColor = `#fff`;
export const lightGrayColor = `#a9a9a9`;
export const darkGrayColor = `#272727`;
export const charcoalColor = `#1b1b1b`;
export const jetBlackColor = `#161616`;
export const blackBeanColor = `#0c0c0c`;
export const blueThemeColor = `#008dbf`;
export const blackInputColor = `#111111`;
export const blackDarkColor = `#1b2226`;
export const pendingColor = `#D9A001`;
export const rejectColor = `#D20000`;
export const acceptColor = `#0CB700`;
export const starColor = `#ffc602`;
export const cancelButtonColor = `#ff4747`;

export const reactIconStyle = {
    fontSize: 20,
    color: blueThemeColor,
    cursor: 'pointer',
};

export const headerStyle = {
    height: 120,
    padding: '10px 30px',
};

export const contentStyle = {
    minHeight: 120,
    padding: '30px',
    maxHeight: '100vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    background: `url(${media})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    color: whiteColor,
    backgroundColor: browserName === 'Safari' ? blackBeanColor : blackColor,

    WebkitBackgroundSize: 'cover',
    MozBackgroundSize: 'cover',
    OBackgroundSize: 'cover',
    backgroundSize: 'cover',
};
